import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { useClinica } from '../../hooks/clinica';
import { PERMISSAO_INDIVIDUAL, TIPO_USUARIO } from '../../utils/funcoes';

import { Content, SidebarHeader, MenuHeader, MenuLink } from './styles';

const Avatar: React.FC = () => {
  const { user, clinica } = useAuth();
  const { optionsClinica } = useClinica();

  const permissoes = useMemo(() => {
    return user.UsuPermissao.split(',');
  }, [user.UsuPermissao]);

  const acessaCobranca = useMemo(() => {
    return (
      user.UsuTipo <= TIPO_USUARIO.SUPERVISOR ||
      user.UsuTipo === TIPO_USUARIO.COBRANCA
    );
  }, [user.UsuTipo]);

  const supervisorAdmin = useMemo(() => {
    return user.UsuTipo <= TIPO_USUARIO.SUPERVISOR;
  }, [user.UsuTipo]);

  return (
    <Content className="border-right d-print-none">
      <SidebarHeader>Administrativo</SidebarHeader>
      {supervisorAdmin && (
        <>
          <MenuHeader> Geral</MenuHeader>
          {user.UsuCodigo === 1 && (
            <MenuLink>
              <Link to="/clinicas">Clinicas</Link>
            </MenuLink>
          )}
          <MenuLink>
            <Link to="/usuario">Usuários</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/medico">Médicos</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/perfil">Perfil</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/agendaCadastro">Agendas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/dianaoagendar">Dia Não Agendar</Link>
          </MenuLink>
          {user.UsuTipo <= clinica.CliPerfilAcessaProcedimentos && (
            <MenuLink>
              <Link to="/procedimento">Procedimentos</Link>
            </MenuLink>
          )}
          <MenuLink>
            <Link to="/usuariosaniversariantes">
              Colaboradores Aniversariantes
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/cadastrocontrato">Contratos</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/palavrasbloqueadas">Palavras Bloqueadas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/grupoexames">Grupo de Exames</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/MedicoEncaminhamento">Médico Encaminhamento</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/UnidadeSaudeEncaminhamento">Unidade Encaminhamento</Link>
          </MenuLink>
        </>
      )}

      {supervisorAdmin && (
        <>
          <MenuHeader> Prontuário</MenuHeader>
          <MenuLink>
            <Link to="/modelodocumento">Atestados, Receitas e Prontuários</Link>
          </MenuLink>
        </>
      )}
      {user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
        <>
          {' '}
          <MenuHeader> Relacionamento Paciente</MenuHeader>
          <MenuLink>
            <Link to="/atendimentoparticular">Atendimentos Particulares</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/aniversariantes">Pacientes Aniversariantes</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/agendaenvioconfirmacao">Confirmação Agendamento</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pacientebuscaavancada">Busca Avançada</Link>
          </MenuLink>
        </>
      )}
      {supervisorAdmin && (
        <MenuLink>
          <Link to="/modelomensagem">Modelos de Mensagem</Link>
        </MenuLink>
      )}
      {user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
        <>
          {' '}
          <MenuHeader> Relacionamento Médico</MenuHeader>
          <MenuLink>
            <Link to="/consultarpagamentosMedicos">Consultar Pagamentos</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pagamentosMedicos">Gerar Pagamentos</Link>
          </MenuLink>
          {/* <MenuLink>
            <Link to="/pagamentosMedicos">Modelo de Recibo</Link>
          </MenuLink> */}
        </>
      )}

      {user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
        <MenuHeader> Financeiro</MenuHeader>
      )}
      {supervisorAdmin && (
        <>
          <MenuLink>
            <Link to="/despesas">Despesas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/despesasresumo">Demonstrativo de Despesas</Link>
          </MenuLink>

          <MenuLink>
            <Link to="/outrasreceitas">Outras Receitas</Link>
          </MenuLink>
        </>
      )}
      {clinica.CliEmiteNotaFiscal === true &&
        user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
          <>
            <MenuLink>
              <Link to="/servicosnotafiscal">Serviços Nota Fiscal</Link>
            </MenuLink>
            <MenuLink>
              <Link to="/notasfiscais">Nota Fiscal</Link>
            </MenuLink>
            <MenuLink>
              <Link to="/relatorionotasfiscais">Relatório Notas Fiscais</Link>
            </MenuLink>
          </>
        )}
      {supervisorAdmin && (
        <>
          <MenuHeader> Relatórios</MenuHeader>
          <MenuLink>
            <Link to="/produtividade">Produtividade</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/fechamentocaixa">Fechamento Caixa</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/fechamentodia">Fechamento do Dia</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/fechamentoconferencia">Fechamento Conferencia</Link>
          </MenuLink>
        </>
      )}
      {user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
        <MenuLink>
          <Link to="/procedimentosrealizados">Procedimentos Realizados</Link>
        </MenuLink>
      )}
      {supervisorAdmin && (
        <>
          <MenuLink>
            <Link to="/procedimentosrealizadosvalor">
              Procedimentos Realizados Valor
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/quantidadeprocedimentos">
              Quantidade de Procedimentos Realizados
            </Link>
          </MenuLink>
          {clinica.CliAtendeConvenio && (
            <MenuLink>
              <Link to="/procedimentosrealizadosconvenio">
                Procedimentos Realizados Convênio
              </Link>
            </MenuLink>
          )}
          {/* {!clinica.CliDrSaude && (
            <MenuLink>
              <Link to="/fechamentoterceiro">
                Fechamento de exames realizados em terceiro (Raio-x e
                Tomografia) - Teste
              </Link>
            </MenuLink>
          )} */}
          <MenuLink>
            <Link to="/resumogerencial">Resumo Gerencial</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/resumocartaosaude">Resumo Cartão Saúde</Link>
          </MenuLink>
        </>
      )}

      <MenuLink>
        <Link to="/cartaosaudelistagem">Cartão Saúde Listagem</Link>
      </MenuLink>
      {user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
        <>
          <MenuLink>
            <Link to="/encaminhamentos">
              Encaminhamentos de Médicos e Unidades
            </Link>
          </MenuLink>
        </>
      )}
      {supervisorAdmin && optionsClinica.length > 1 && (
        <>
          <MenuLink>
            <Link to="/pagaroutraunidade">À Pagar Outra Unidade</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/receberoutraunidade">À Receber Outra Unidade</Link>
          </MenuLink>
        </>
      )}
      {supervisorAdmin && (
        <>
          <MenuLink>
            <Link to="/registrologinpordia">Registro de Login</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/consumocartao">Consumo por Cartão</Link>
          </MenuLink>
        </>
      )}

      {supervisorAdmin && (
        <>
          <MenuHeader>Agendamentos</MenuHeader>
          <MenuLink>
            <Link to="/dashboardagendamento">Dashboard Agendamento</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/medicosagendamentos">Agendamentos por Médico</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/dashboardmedico">Dashboard Médico</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/agendamentosrealizados">Agendamentos Realizados</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pedidoexamesprocedimentos">
              Pedido Exames Procedimentos Detalhe
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pedidoexamesquantidadeprocedimentos">
              Pedido Exames Quantidade Procedimentos
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pedidoexamesgerencial">
              Pedido Exames Gerencial Valores
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pedidoencaminhamentosquantidade">
              Pedido Encaminhamentos Por Especialidade
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pedidoencaminhamentosgerencial">
              Pedido Encaminhamentos Gerencial Valores
            </Link>
          </MenuLink>
        </>
      )}

      {supervisorAdmin && (
        <>
          <MenuHeader> Laboratório Álvaro</MenuHeader>

          <MenuLink>
            <Link to="/examessolicitados">Exames Solicitados</Link>
          </MenuLink>

          <MenuLink>
            <Link to="/conferenciaexamesalvaro">
              Conferência Exames Cobrados
            </Link>
          </MenuLink>

          <MenuLink>
            <Link to="/lucroexamesalvaro">Lucro Laboratório</Link>
          </MenuLink>
        </>
      )}

      <MenuHeader> Cobrança</MenuHeader>
      {(acessaCobranca ||
        permissoes.some(
          permissao => permissao === PERMISSAO_INDIVIDUAL.COBRANCAS_COBRAR,
        )) && (
        <MenuLink>
          <Link to="/atrasados">Cobrança</Link>
        </MenuLink>
      )}
      {(acessaCobranca ||
        permissoes.some(permissao => {
          return [
            PERMISSAO_INDIVIDUAL.COBRANCAS_REALIZADAS,
            PERMISSAO_INDIVIDUAL.COBRANCAS_RESUMO,
            PERMISSAO_INDIVIDUAL.COBRANCAS_RECEBIMENTO_31,
            PERMISSAO_INDIVIDUAL.COBRANCAS_RECEBIMENTO_MES,
          ].includes(permissao);
        })) && (
        <>
          {(acessaCobranca ||
            permissoes.some(
              permissao =>
                permissao === PERMISSAO_INDIVIDUAL.COBRANCAS_REALIZADAS,
            )) && (
            <MenuLink>
              <Link to="/cobrancasrealizadas">Cobranças Realizadas</Link>
            </MenuLink>
          )}
          {(acessaCobranca ||
            permissoes.some(
              permissao => permissao === PERMISSAO_INDIVIDUAL.COBRANCAS_RESUMO,
            )) && (
            <MenuLink>
              <Link to="/resumocobrancas">Resumo de Cobranças</Link>
            </MenuLink>
          )}
          {(acessaCobranca ||
            permissoes.some(
              permissao =>
                permissao === PERMISSAO_INDIVIDUAL.COBRANCAS_RECEBIMENTO_31,
            )) && (
            <MenuLink>
              <Link to="/recebimentos31">Recebimentos mais de 31 dias</Link>
            </MenuLink>
          )}
          {(acessaCobranca ||
            permissoes.some(
              permissao =>
                permissao === PERMISSAO_INDIVIDUAL.COBRANCAS_RECEBIMENTO_MES,
            )) && (
            <MenuLink>
              <Link to="/recebimentosmes">Recebimentos dentro do mês</Link>
            </MenuLink>
          )}
        </>
      )}
      {clinica.IntegracaoWhatsapp && user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuHeader> Integrações</MenuHeader>

          <MenuLink>
            <Link to="/whatsapp">Whatsapp</Link>
          </MenuLink>
        </>
      )}
    </Content>
  );
};

export default Avatar;
